
 

// 3. Missing heading mark-up //
  $(function () {
          $('.MegaMenu__Item.MegaMenu__Item--fit span').replaceWith(function () {
          return jQuery("<h2>", {
           class: this.className,
           html: jQuery(this).html(),
           style: jQuery(this).attr('style')
         });
      });
  });
// 3. Missing heading mark-up //

// 9. Note: Inappropriate label for navigation region
   $("#section-header nav").attr("aria-label", "Main");
// 9. Note: Inappropriate label for navigation region

  
 //4. Unnecessary alt text for image links
    setTimeout(function()
    {
        $('.MegaMenu__PushImageWrapper.AspectRatio img').attr('alt', '');
    }, 5000);
//4. Unnecessary alt text for image links
 
 //Ticket 6 : Purpose of input field not identified programmatically
  $("#footer-newsletter").find(".Form__Input").attr("autocomplete", "Email");   
 //Ticket 6 : Purpose of input field not identified programmatically

// Ticket 7 : Status message not announced for screen reader users
  $(".Footer__Newsletter p").attr("aria-live","polite");
  $(".Footer__Newsletter p").attr("role","status");
// Ticket 7 : Status message not announced for screen reader users

// 14. Heading mark-up used inappropriately

 $('#shopify-section-1543615366072 h3').replaceWith(function () {
        return jQuery("<p>", {
         class: this.className,
         html: jQuery(this).html(),
         style: jQuery(this).attr('style')
       });
    });

// 14. Heading mark-up used inappropriately


// 2. Missing visual label for input field
   $("#section-footer form label").attr("class", "");
// 2. Missing visual label for input field


// Ticket : 21 Redundant alternative text for image links
$(".ProductItem .ProductItem__Wrapper a").attr("aria-hidden", "true");
// Ticket : 21 Redundant alternative text for image links

// Ticket : 25 Redundant alternative text for image links
  jQuery(".ProductList .ProductItem__Wrapper a").attr("aria-hidden", "true");
// Ticket : 25 Redundant alternative text for image links

// Ticket : 30 Error messages difficult to locate
setTimeout(function()
    {
        jQuery('.new-review-form .stamped-form-contact input').each(function() {
        var id = jQuery(this ).attr( "id" );
          jQuery(this).attr( "aria-describedby",id );
      });
    }, 5000);
// Ticket : 30 Error messages difficult to locate


// 31. Mandatory fields are not identified
setTimeout(function() {
    $('.stamped-form-contact label').append('<span>*</span>');
    $('.stamped-form-review label').append('<span>*</span>');
    $(".stamped-summary-actions-newreview").click(function(){
    $("#remove").remove();
     $(".stamped-form-contact").prepend('<p id="remove">* These fields are mandatory</p>'); 
    });
 }, 4000);
// 31. Mandatory fields are not identified


// 19. Heading mark-up used inappropriately
setTimeout(function() {
  jQuery('.collection-toolbar--block .u-h1, .CollectionMain .u-h1').replaceWith(function () {
       return jQuery("<p>", {
       class: this.className,
       html: jQuery(this).html(),
       style: jQuery(this).attr('style')
     });
  });
   }, 5000);

// 10. Custom input field inaccessible for screen reader users
setTimeout(function() {
  $("#Search form").prepend('<span class="offleft">Start typing, then use the up and down arrows to select an option from the list</span>');
}, 5000);

// 1. Sub-menu links displayed on keyboard focus
  jQuery('.Header__MainNav .HorizontalList__Item a.Heading').attr('aria-expanded','false');
  jQuery('.Header__MainNav .HorizontalList__Item .MegaMenu  ').removeAttr('aria-hidden');
  jQuery('.Header__MainNav .HorizontalList__Item').each(function () {
    var menu_link = jQuery(this).attr('aria-haspopup');
    if(menu_link){
       var label_menu = jQuery(this).children(":first").find('span').text();
      // console.log(label_menu);
      jQuery(this).children(":first").append('<span class="arrow-btn" style="margin-left:3px;">&#9046;</span>');
       jQuery(this).children(":first").find('span:eq(1)').attr('aria-label',label_menu+' menu');
    }
  });
  jQuery(document).on('focusin', '.Header__MainNav .HorizontalList__Item a.Heading', function(event){
    var menu_link = jQuery(this).parent().attr('aria-haspopup');
        if(menu_link) {
          jQuery(this).next().removeAttr('aria-hidden');
          jQuery(this).parent().removeClass("focused");
          jQuery(this).attr("aria-expanded", "false");
          jQuery("li.HorizontalList__Item a.Heading").not(this).find('span:eq(1)').css('transform','rotateX(0deg)');
        } else {
          jQuery(this).parent().addClass("is-expanded");
        }
   });
   jQuery(document).on('focusout', '.Header__MainNav .HorizontalList__Item a.Heading', function(event){
     jQuery(this).parent().removeClass("is-expanded");
   });
 
    jQuery('.Header__MainNav').on("keydown", "li.HorizontalList__Item:not(.focused)",function(e) {
      if(event.keyCode == 13 ||  event.keyCode == 32 ) {
        var menu_link = jQuery(this).attr('aria-haspopup');
        if(menu_link) {
        jQuery('.Header__MainNav').find("li.HorizontalList__Item.focused").removeClass("focused")
        jQuery(this).find('.MegaMenu  ').attr("aria-hidden", "true");
        e.preventDefault();
          jQuery(this).addClass("focused");
          jQuery(this).children(":first").attr("aria-expanded","true");
          jQuery(this).find('.MegaMenu  ').attr("aria-hidden", "false");
          jQuery(this).children(":first").find('span:eq(1)').css('transform','rotateX(-180deg)');
          return false;
        }
      }
    });

    jQuery("li.HorizontalList__Item").on('mouseover',function(){
       var menu_link = jQuery(this).attr('aria-haspopup');
        if(menu_link) {
          jQuery(this).find('.MegaMenu  ').attr("aria-hidden", "false");
          jQuery(this).find('a:eq(0)').attr("aria-expanded","true");
          jQuery(this).find('span:eq(1)').css('transform','rotateX(-180deg)');
        }
    });

    jQuery("li.HorizontalList__Item").on('mouseout',function(){
       var menu_link = jQuery(this).attr('aria-haspopup');
       if(menu_link) {
         jQuery(this).removeClass("focused")
         jQuery(this).find('.MegaMenu  ').removeAttr('aria-hidden');
         jQuery(this).find('a:eq(0)').attr("aria-expanded","false");
         jQuery(this).find('span:eq(1)').css('transform','rotateX(0deg)');
        }
    });

    jQuery(".Header__MainNav").on("keyup", "li.HorizontalList__Item", function(e){
      if(e.keyCode == 9 ||  e.keyCode == 32){
        jQuery("li.HorizontalList__Item").not(this).removeClass("focused");
        jQuery("li.HorizontalList__Item").not(this).find("a").attr("aria-expanded", "false");
        jQuery("li.HorizontalList__Item").not(this).children(":first").find('span:eq(1)').css('transform','rotateX(0deg)');
        // console.log(jQuery("li.HorizontalList__Item").not(this).children(":first").find('span:eq(1)').css('transform','rotateX(0deg)'));
        jQuery("li.HorizontalList__Item").not(this).find('.MegaMenu  ').removeAttr('aria-hidden');
        jQuery(this).find(".MegaMenu  ").find("li a").removeAttr("aria-expanded");
        e.preventDefault();
      } 
      if(e.keyCode == 27) { 
        e.preventDefault();
        jQuery(this).closest('li.HorizontalList__Item').find('a').first().focus();
        jQuery(this).closest('li.HorizontalList__Item').children(":first").find('span:eq(1)').css('transform','rotateX(0deg)');
        jQuery(this).closest('li.HorizontalList__Item').removeClass("focused");
        jQuery(this).closest('li.HorizontalList__Item').find('a').first().attr("aria-expanded","false");
        jQuery(this).find('.MegaMenu  ').removeAttr('aria-hidden');
        return false;
      }

    });

   jQuery('body').on("keyup", ".HorizontalList__Item .Link--primary",function(e) {
      jQuery("li.HorizontalList__Item").find('.MegaMenu  ').removeAttr('aria-hidden');
      jQuery("li.HorizontalList__Item").removeClass("focused");
      jQuery("li.HorizontalList__Item a.Heading").attr("aria-expanded", "false");
      jQuery("li.HorizontalList__Item a.Heading").find('span').css('transform','rotateX(0deg)');
    });
// 1. Sub-menu links displayed on keyboard focus
    







